module.exports = __webpack_public_path__ + "img/catalog.1e05279c.jpg";